<template lang="html">

  <nav class="rrss">
    <a rel="noopener" target="_blank" href="https://www.facebook.com/InerEnergia/" aria-label="facebook"><i
        class="fa fa-facebook"></i></a>
    <a rel="noopener" target="_blank" href="https://www.linkedin.com/company/inerenergia/" aria-label="linkedin"><i
        class="fa fa-linkedin"></i></a>
    <a rel="noopener" target="_blank" href="https://www.instagram.com/inerenergia/" aria-label="instagram"><i
        class="fa fa-instagram"></i></a>
    <a rel="noopener" target="_blank" href="https://www.youtube.com/channel/UC7hfd17w1iexc3T2NKsOZKA"
      aria-label="youtube"><i class="fa fa-youtube-play"></i></a>
  </nav>

</template>

<script lang="js">
export default {
  name: 'rrss',
}
</script>

<style scoped lang="scss">
.rrss {
  margin: 0 20px;

  a {
    padding: 0 6px;
    text-align: center;
    display: inline-block;
    font-size: 20px;
  }
}

footer .rrss {
  margin-bottom: 10px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: flex-start;
  min-width: 137px;
  padding-left: 28px;
}

footer .rrss a {
  padding: 0 7px;
}

@media screen and (max-width: 870px) {
  footer .rrss {
    margin-bottom: 0;
    justify-content: flex-end;
    min-width: 91px;
    padding-left: 0px;
  }
}

@media screen and (max-width: 650px) {
  .header .rrss a {
    padding: 0 3px;
    font-size: 14px;
  }
}


@media screen and (max-width: 450px) {
  footer .rrss {
    min-width: 100px;
  }

  footer .rrss a {
    padding: 0 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/rrss.vue